export function datepicker() {
    $(".datepicker-holder input").datepicker({
        dateFormat: "yy-mm-dd"
    });
}



// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/datepicker.js